import { useEffect, useState } from "react";
import { Activity } from "lucide-react";
import Dropdown from "../ui/Dropdown";
import GlassCard from "../ui/GlassCard";
import StatPill from "../ui/StatPill";
const months = ["January","February","March","April","May","June","July","August","September","October","November","December"];
const Workshops = () => {
  const [selectedMonth, setSelectedMonth] = useState("");
  useEffect(() => {
    const currentMonthIndex = new Date().getMonth();
    setSelectedMonth(months[currentMonthIndex]);
  }, []);
  const handleMonthChange = (event) => setSelectedMonth(event.target.value);
  return (
    <GlassCard accent="violet" className="flex flex-col gap-4 text-slate-900 dark:text-white">
      <div className="w-full flex flex-row items-start justify-between">
        <h1 className="font-['Space_Grotesk',_sans-serif] text-[22px] leading-tight font-semibold flex flex-col">
          Workshops <span className="text-[12px] font-normal text-slate-400 dark:text-white/40 mt-0.5">Coming soon</span>
        </h1>
        <div className="shrink-0 rounded-xl bg-black/[0.03] dark:bg-white/[0.04] border border-black/[0.06] dark:border-white/[0.06]">
          <Dropdown value={selectedMonth} onChange={handleMonthChange} options={months} label="Month" />
        </div>
      </div>
      <div className="flex flex-row gap-8 items-center">
        <StatPill icon={<Activity size={18} />} value="10k" label="Total workshops" accent="#8C7CF0" iconChip={false} />
        <StatPill icon={<Activity size={18} />} value={45} label="Workshops this month" accent="#F0498C" iconChip={false} />
      </div>
    </GlassCard>
  );
};
var Workshops_default = Workshops;
export { Workshops_default as default };